module.exports = __webpack_public_path__ + "public/images/brain-with-glasses.045258e5b94e778be4cb7d9d222d3860.png";